/* tslint:disable */

declare var Object: any;
export interface CommissionUploadInterface {
  "username": string;
  "orderId": string;
  "reference": string;
  "paymentMethod": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "orderItemId": string;
  "productType": string;
  "planType": string;
  "quantity": number;
  "unitPrice": number;
  "unitDiscount": number;
  "discountUnit": string;
  "uploadId": number;
  "orderIndex": number;
  "status"?: number;
  "completedDate"?: Date;
  "error"?: string;
  "id"?: number;
}

export class CommissionUpload implements CommissionUploadInterface {
  "username": string;
  "orderId": string;
  "reference": string;
  "paymentMethod": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "orderItemId": string;
  "productType": string;
  "planType": string;
  "quantity": number;
  "unitPrice": number;
  "unitDiscount": number;
  "discountUnit": string;
  "uploadId": number;
  "orderIndex": number;
  "status": number;
  "completedDate": Date;
  "error": string;
  "id": number;
  constructor(data?: CommissionUploadInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CommissionUpload`.
   */
  public static getModelName() {
    return "CommissionUpload";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CommissionUpload for dynamic purposes.
  **/
  public static factory(data: CommissionUploadInterface): CommissionUpload{
    return new CommissionUpload(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CommissionUpload',
      plural: 'CommissionUploads',
      path: 'CommissionUploads',
      idName: 'id',
      properties: {
        "username": {
          name: 'username',
          type: 'string'
        },
        "orderId": {
          name: 'orderId',
          type: 'string'
        },
        "reference": {
          name: 'reference',
          type: 'string'
        },
        "paymentMethod": {
          name: 'paymentMethod',
          type: 'number',
          default: 0
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
        "lastUpdated": {
          name: 'lastUpdated',
          type: 'Date'
        },
        "orderItemId": {
          name: 'orderItemId',
          type: 'string'
        },
        "productType": {
          name: 'productType',
          type: 'string'
        },
        "planType": {
          name: 'planType',
          type: 'string'
        },
        "quantity": {
          name: 'quantity',
          type: 'number'
        },
        "unitPrice": {
          name: 'unitPrice',
          type: 'number',
          default: 0
        },
        "unitDiscount": {
          name: 'unitDiscount',
          type: 'number',
          default: 0
        },
        "discountUnit": {
          name: 'discountUnit',
          type: 'string',
          default: 'P'
        },
        "uploadId": {
          name: 'uploadId',
          type: 'number'
        },
        "orderIndex": {
          name: 'orderIndex',
          type: 'number'
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "completedDate": {
          name: 'completedDate',
          type: 'Date'
        },
        "error": {
          name: 'error',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
